/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import { UIStrings } from '@sonatype/nexus-ui-plugin';

export default {
  ...UIStrings,
  CROWD_SETTINGS: {
    MENU: {
      text: 'Atlassian Crowd',
      description: 'Manage Atlassian Crowd configuration'
    },
    FIELDS: {
      enabledLabel: 'Enable Crowd',
      enabledDescription: 'Enable Crowd Capability',
      realmActiveLabel: 'Enable Crowd Realm for authentication',
      realmActiveDescription: {__html: 'To control ordering, go to <a href="#admin/security/realms">Realms</a> page.'},
      urlLabel: 'Crowd server URL',
      urlDescription: 'For example: http://localhost:8095/crowd',
      urlValidationError: 'URL is not valid',
      useTrustStoreLabel: 'Use the NXRM truststore',
      useTrustStoreDescription: 'Use certificates stored in the NXRM truststore to connect to external systems',
      applicationNameLabel: 'Crowd application name',
      applicationPasswordLabel: 'Crowd application password',
      timeoutLabel: 'Connection timeout',
      timeoutDescription: 'Seconds to wait for activity before stopping and retrying the connection. Leave blank to use the globally defined HTTP timeout.',
    },
    MESSAGES: {
      LOAD_ERROR: 'An error occurred while loading Atlassian Crowd settings',
      SAVE_SUCCESS: 'Atlassian Crowd settings updated',
      SAVE_ERROR: 'An error occurred while updating Atlassian Crowd settings',
      VERIFY_CONNECTION_SUCCESS: 'Connection to Crowd server verified',
      VERIFY_CONNECTION_ERROR: 'An error occurred while verifying connection to the Crowd server',
      CLEAR_CACHE_SUCCESS: 'Crowd cache has been cleared',
      CLEAR_CACHE_ERROR: 'An error occurred while clearing Crowd cache'
    },
    BUTTONS: {
      VERIFY_BUTTON_LABEL: 'Verify connection',
      CLEAR_BUTTON_LABEL: 'Clear cache'
    }
  },
  SAML_CONFIGURATION: {
    MENU: {
      text: 'SAML',
      description: 'SAML Identity Provider Configuration'
    },
    FIELDS: {
      idpMetadataLabel: 'SAML Identity Provider Metadata XML',

      entityIdUriLabel: 'Entity ID URI',
      entityIdUriDescription: 'Unique identifier for this Service Provider.  Normally the default Entity ID can be used unless NXRM does not have a fixed URL and or port.',
      entityIdUriValidationError: 'Entity ID must be a URI',

      validateResponseSignatureLabel: 'Validate Response Signature',
      validateResponseSignatureDescription: 'By default, if a signing key is found in the IdP metadata, then NXRM will attempt to validate signatures on the response.',

      validateAssertionSignatureLabel: 'Validate Assertion Signature',
      validateAssertionSignatureDescription: 'By default, if a signing key is found in the IdP metadata, then NXRM will attempt to validate signatures on the assertions.',

      defaultRoleLabel: 'Default Role Mapping',
      defaultRoleDescription: 'The role a user should be assigned if no other roles were able to be mapped to the user',

      usernameAttrLabel: 'Username',

      firstNameAttrLabel: 'First Name',

      lastNameAttrLabel: 'Last Name',

      emailAttrLabel: 'Email',

      roleAttrLabel: 'Roles/Groups',
      roleFieldDescription: 'Map Identity Provider roles or groups to Nexus Repository Manager roles'
    },

    MESSAGES: {
      LOAD_ERROR: 'An error occurred while attempting to load the SAML Identity Provider configuration',
      SAVE_ERROR: 'An error occurred while attempting to save the SAML Identity Provider configuration',
      SAVE_SUCCESS: 'SAML Identity Provider configuration updated'
    }
  },
  USER_TOKEN: {
    MENU: {
      text: 'User Token',
      description: 'Access Nexus Repository Manager without the use of passwords'
    },
    LABELS: {
      ACCESS_NOTE: 'A new user token will be created the first time it is accessed.',
      RESET_NOTE: 'Resetting your user token will invalidate the current token and force a new token to be created the next time it is accessed.',
      USER_TOKEN_NOTE: 'User tokens are a combination of a name and password codes.',
      KEEP_SECRET_NOTE: 'Keep these codes secret.',
      USER_TOKEN_NAME_CODE: 'Your user token name code is:',
      USER_TOKEN_PASS_CODE: 'Your user token pass code is:',
      MAVEN_USAGE: 'Use the following in your Maven settings.xml:',
      BASE64_USER_TOKEN: 'Use the following for a base64 representation of "user:password":',
      AUTO_HIDE: 'This window will automatically close after one minute.',
    },
    MESSAGES: {
      ACCESS_AUTHENTICATION: 'Accessing user tokens requires validation of your credentials',
      RESET_AUTHENTICATION: 'Resetting user tokens requires validation of your credentials',
    },
    BUTTONS: {
      ACCESS: 'Access user token',
      RESET: 'Reset user token',
      CLOSE: 'Close'
    }
  }
};
